import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Alert, Button, Tab, Tabs, Panel, Form } from 'react-bootstrap';
import ReactSelect from 'react-select';
import NCRForm from './NCRForm';
import IPIForm from './IPIForm';
import CustomerComplaintForm from './CustomerComplaintForm';

function EnhancedNCRForm({
  onFormSubmitSuccess,
  onFormSubmitError,
  initialTab = 'ncr',
  onTabChange,
  history,
  location
}) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const onTabChangeRef = useRef(onTabChange);

  useEffect(() => {
    onTabChangeRef.current = onTabChange;
  }, [onTabChange]);

  useEffect(() => {
    setActiveTab(initialTab);
    if (onTabChangeRef.current) {
      onTabChangeRef.current(initialTab);
    }
  }, [initialTab]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    if (onTabChangeRef.current) {
      onTabChangeRef.current(tabKey);
    }
    // Update URL to reflect the active tab
    history.push({
      pathname: `/quality-issue-form/${tabKey}`,
      search: location?.search || ''
    });
  };

  const handleFormSuccess = (data) => {
    setShowSuccessModal(true);
    onFormSubmitSuccess(data);
  };

  const handleFormError = (error) => {
    setErrorMessage(error);
    setShowErrorAlert(true);
    onFormSubmitError(error);
    setTimeout(() => setShowErrorAlert(false), 5000);
  };

  return (
    <div className="enhanced-ncr-wrapper">
      {showErrorAlert && (
        <Alert
          bsStyle="danger"
          onDismiss={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}

      <div className="ncr-tabs-container">
        <div className="ncr-tabs-sidebar">
          <div
            className={`ncr-tab-button ${activeTab === 'ncr' ? 'active' : ''}`}
            onClick={() => handleTabChange('ncr')}
          >
            <div className="tab-button-content">
              <span className="tab-icon">📋</span>
              <span className="tab-title">NCR</span>
              <span className="tab-subtitle">Non-Conformance Report</span>
            </div>
          </div>
          <div
            className={`ncr-tab-button ${activeTab === 'ipi' ? 'active' : ''}`}
            onClick={() => handleTabChange('ipi')}
          >
            <div className="tab-button-content">
              <span className="tab-icon">⚙️</span>
              <span className="tab-title">IPI</span>
              <span className="tab-subtitle">In-Process Issue</span>
            </div>
          </div>
          <div
            className={`ncr-tab-button ${activeTab === 'customer-complaint' ? 'active' : ''}`}
            onClick={() => handleTabChange('customer-complaint')}
          >
            <div className="tab-button-content">
              <span className="tab-icon">👤</span>
              <span className="tab-title">Customer Complaint</span>
              <span className="tab-subtitle">External Feedback</span>
            </div>
          </div>
        </div>

        <div className="ncr-tabs-content">
          {activeTab === 'ncr' && (
            <div className="ncr-form-wrapper">
              <NCRForm
                onFormSubmitSuccess={handleFormSuccess}
                onFormSubmitError={handleFormError}
              />
            </div>
          )}

          {activeTab === 'ipi' && (
            <div className="ncr-form-wrapper">
              <IPIForm
                onFormSubmitSuccess={handleFormSuccess}
                onFormSubmitError={handleFormError}
              />
            </div>
          )}

          {activeTab === 'customer-complaint' && (
            <div className="ncr-form-wrapper">
              <CustomerComplaintForm
                onFormSubmitSuccess={handleFormSuccess}
                onFormSubmitError={handleFormError}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default withRouter(EnhancedNCRForm);
